<template>
  <div :class="withStickySubmitters ? 'sticky top-0 z-[1]' : ''">
    <FieldSubmitter
      :model-value="selectedSubmitter.uuid"
      class="roles-dropdown w-full rounded-lg roles-dropdown"
      :style="withStickySubmitters ? { backgroundColor } : {}"
      :submitters="submitters"
      :menu-style="{ overflow: 'auto', display: 'flex', flexDirection: 'row', maxHeight: 'calc(100vh - 120px)', backgroundColor: ['', null, 'transparent'].includes(backgroundColor) ? 'white' : backgroundColor }"
      :editable="editable && !defaultSubmitters.length"
      @new-submitter="save"
      @remove="removeSubmitter"
      @name-change="save"
      @update:model-value="$emit('change-submitter', submitters.find((s) => s.uuid === $event))"
    />
  </div>
  <div
    v-if="false"
    class="bg-blue-50 border border-blue-300 rounded-lg px-3 py-2 mb-2 mt-2"
  >
    <div class="flex items-center justify-between mb-1.5">
      <span class="text-xs text-blue-700 font-semibold uppercase tracking-wide">Align Fields ({{ alignmentFieldUuids.value.size }})</span>
      <button class="btn btn-xs btn-ghost text-blue-600" @click="clearAlignmentSelection"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6l-12 12"/><path d="M6 6l12 12"/></svg></button>
    </div>
    <div class="flex gap-1 flex-wrap">
      <button class="btn btn-xs bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200 gap-1" title="Align Left" @click="alignFields('left')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="3" y2="12"/><rect x="3" y="5" width="10" height="4"/><rect x="3" y="15" width="16" height="4"/><line x1="3" y1="3" x2="3" y2="21"/></svg>
        Left
      </button>
      <button class="btn btn-xs bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200 gap-1" title="Align Center" @click="alignFields('center')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="3" x2="12" y2="21"/><rect x="7" y="5" width="10" height="4"/><rect x="4" y="15" width="16" height="4"/></svg>
        Center
      </button>
      <button class="btn btn-xs bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200 gap-1" title="Align Right" @click="alignFields('right')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="21" y1="3" x2="21" y2="21"/><rect x="11" y="5" width="10" height="4"/><rect x="5" y="15" width="16" height="4"/></svg>
        Right
      </button>
      <button class="btn btn-xs bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200 gap-1" title="Align Top" @click="alignFields('top')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="3" x2="21" y2="3"/><rect x="5" y="3" width="4" height="10"/><rect x="15" y="3" width="4" height="16"/></svg>
        Top
      </button>
      <button class="btn btn-xs bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200 gap-1" title="Align Middle" @click="alignFields('middle')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="21" y2="12"/><rect x="5" y="7" width="4" height="10"/><rect x="15" y="4" width="4" height="16"/></svg>
        Middle
      </button>
      <button class="btn btn-xs bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200 gap-1" title="Align Bottom" @click="alignFields('bottom')">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="21" x2="21" y2="21"/><rect x="5" y="11" width="4" height="10"/><rect x="15" y="5" width="4" height="16"/></svg>
        Bottom
      </button>
    </div>
  </div>
  <div
    v-if="false && selectedFieldUuids && selectedFieldUuids.value && selectedFieldUuids.value.size > 0"
    class="bg-purple-50 border border-purple-300 rounded-lg px-3 py-2 mb-2 mt-2"
  >
    <div class="flex items-center justify-between mb-2">
      <span class="text-sm text-purple-700 font-medium">{{ selectedFieldUuids.value.size }} field{{ selectedFieldUuids.value.size > 1 ? 's' : '' }} selected</span>
      <button class="btn btn-xs btn-ghost text-purple-600 gap-1" @click="clearSelection"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6l-12 12"/><path d="M6 6l12 12"/></svg>Clear</button>
    </div>
    <div class="flex flex-wrap gap-3 mb-2">
      <label class="flex items-center gap-1.5 cursor-pointer text-xs text-purple-800 font-medium">
        <input type="checkbox" class="checkbox checkbox-xs checkbox-primary" :checked="bulkAllRequired" @change="setBulkProp('required', $event.target.checked)" />
        Required
      </label>
      <label class="flex items-center gap-1.5 cursor-pointer text-xs text-purple-800 font-medium">
        <input type="checkbox" class="checkbox checkbox-xs" :checked="bulkAllReadonly" @change="setBulkProp('readonly', $event.target.checked)" />
        Read Only
      </label>
    </div>
    <div v-if="bulkAllText" class="mb-2 space-y-2">
      <div class="relative">
        <select
          class="select select-bordered select-xs w-full font-normal"
          :value="bulkValidation"
          @change="setBulkValidation($event.target.value)"
        >
          <option value="none">None</option>
          <option value="email">Email</option>
          <option value="url">URL</option>
          <option value="numbers">Numbers only</option>
          <option value="letters">Letters only</option>
          <option value="zip">ZIP</option>
          <option value="ssn">SSN</option>
          <option value="ein">EIN</option>
        </select>
        <label class="absolute -top-1.5 left-2 px-1 text-purple-600 bg-purple-50" style="font-size:8px">Validation</label>
      </div>
      <div class="flex gap-2">
        <div class="relative flex-1">
          <select
            class="select select-bordered select-xs w-full font-normal"
            :value="bulkFont"
            @change="setBulkFont($event.target.value)"
          >
            <option value="">Default</option>
            <option value="Times">Times</option>
            <option value="Courier">Courier</option>
          </select>
          <label class="absolute -top-1.5 left-2 px-1 text-purple-600 bg-purple-50" style="font-size:8px">Font</label>
        </div>
        <div class="relative w-24">
          <select
            class="select select-bordered select-xs w-full font-normal"
            :value="bulkFontSize"
            @change="setBulkFontSize($event.target.value)"
          >
            <option value="">Auto</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="14">14</option>
            <option value="16">16</option>
            <option value="18">18</option>
            <option value="24">24</option>
          </select>
          <label class="absolute -top-1.5 left-2 px-1 text-purple-600 bg-purple-50" style="font-size:8px">Size</label>
        </div>
      </div>
    </div>
    <div class="flex gap-2">
      <button
        class="btn btn-xs bg-purple-600 text-white border-0 hover:bg-purple-700"
        @click="isBulkConditionModal = true"
      >Set Condition</button>
    </div>
  </div>
  <div
    ref="fields" v-if="false"
    class="fields mb-1 mt-2"
    @dragover.prevent="onFieldDragover"
    @drop="reorderFields"
  >
    <Field
      v-for="field in submitterFields"
      :key="field.uuid"
      :data-uuid="field.uuid"
      :field="field"
      :type-index="fields.filter((f) => f.type === field.type).indexOf(field)"
      :editable="editable"
      :with-signature-id="withSignatureId"
      :with-prefillable="withPrefillable"
      :default-field="defaultFieldsIndex[field.name]"
      :draggable="editable"
      @dragstart="[fieldsDragFieldRef.value = field, removeDragOverlay($event), setDragPlaceholder($event)]"
      @dragend="[fieldsDragFieldRef.value = null, $emit('set-drag-placeholder', null)]"
      @remove="removeField"
      @scroll-to="$emit('scroll-to-area', $event)"
      @set-draw="$emit('set-draw', $event)"
    />
  </div>
  <div v-if="submitterDefaultFields.length && editable">
    <hr class="mb-2">
    <template v-if="isShowFieldSearch">
      <input
        v-model="defaultFieldsSearch"
        :placeholder="t('search_field')"
        class="input input-ghost input-xs px-0 text-base mb-2 !outline-0 !rounded bg-transparent w-full"
      >
      <hr class="mb-2">
    </template>
    <div
      class="overflow-auto relative"
      :style="{
        maxHeight: isShowFieldSearch ? '210px' : '',
        minHeight: isShowFieldSearch ? '210px' : ''
      }"
    >
      <div
        v-if="!filteredSubmitterDefaultFields.length && defaultFieldsSearch"
        class="top-0 bottom-0 text-center absolute flex items-center justify-center w-full flex-col"
      >
        <div>
          {{ t('field_not_found') }}
        </div>
        <a
          href="#"
          class="link"
          @click.prevent="defaultFieldsSearch = ''"
        >
          {{ t('clear') }}
        </a>
      </div>
      <template
        v-for="field in filteredSubmitterDefaultFields"
        :key="field.name"
      >
        <div
          :style="{ backgroundColor }"
          draggable="true"
          :class="['border rounded relative group mb-2 default-field fields-list-item', selectedFieldUuids && selectedFieldUuids.value && selectedFieldUuids.value.has(field.uuid) ? 'border-purple-400 bg-purple-50' : 'border-base-300']"
          @dragstart="onDragstart($event, field)"
          @dragend="$emit('drag-end')"
          @click="toggleFieldSelect($event, field)"
        >
          <div class="flex items-center justify-between relative cursor-grab">
            <div class="flex items-center p-1 space-x-1">
              <IconDrag />
              <FieldType
                :model-value="field.type || 'text'"
                :editable="false"
                :button-width="20"
              />
              <span class="block pl-0.5">
                {{ field.title || field.name }}
              </span>
            </div>
            <span
              v-if="defaultRequiredFields.includes(field)"
              :data-tip="t('required')"
              class="text-red-400 text-3xl pr-1.5 tooltip tooltip-left h-8"
            >
              *
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
  <!-- Palette search. Separate from the `defaultFieldsSearch` above it: that one filters the
       account's prefill fields and only appears past 15 of them. This filters the palette
       itself -- 13 types plus 9 smart fields -- the way DocuSign's "Search Fields" box does. -->
  <div
    v-if="editable && !onlyDefinedFields"
    class="relative mb-2"
  >
    <input
      ref="paletteSearchInput"
      v-model="paletteSearch"
      placeholder="Search fields"
      class="input input-bordered input-xs w-full pr-6"
    >
    <a
      v-if="paletteSearch"
      href="#"
      class="absolute right-1.5 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content leading-none"
      aria-label="Clear search"
      @click.prevent="paletteSearch = ''"
    >&times;</a>
  </div>
  <div
    v-if="editable && !onlyDefinedFields && paletteSearch && !filteredFieldTypeCount && !filteredSmartFields.length"
    class="text-center text-sm text-base-content/60 pb-2"
  >
    {{ t('field_not_found') }}
    <a
      href="#"
      class="link block"
      @click.prevent="paletteSearch = ''"
    >{{ t('clear') }}</a>
  </div>
  <!-- Palette list, one row per type the way DocuSign's reads. Deliberately NOT its own
       scroll container: capping it (45vh, then 100vh) put a second scrollbar right next to
       #fields_list_container's, because 22 rows are ~800px and the CSS viewport is shorter than
       that on a laptop. The panel scrolls as one instead -- #fields_list_container is already
       bounded by #main_container's max-h-[calc(100%-60px)] and owns the only overflow-y in the
       sidebar, so the list runs to its natural height and the help block and Autodetect button
       below it come into view on the same scroll. Nesting another calc here would subtract the
       60px header twice. -->
  <div
    v-if="editable && !onlyDefinedFields"
    class="pb-2 fields-palette"
  >
    <!-- Section headings match the SMART FIELDS divider below rather than introducing a second
         style; the two only read as a pair if they're drawn the same way. Gated on the count of
         field-type buttons, so an account with no types left after a search shows neither. -->
    <div
      v-if="filteredFieldTypeCount"
      style="display:flex;align-items:center;gap:6px;padding:0 4px 4px;"
    >
      <div style="height:1px;flex:1;background:#e5e7eb;"></div>
      <span style="font-size:10px;font-weight:700;color:#9ca3af;letter-spacing:.8px;text-transform:uppercase;white-space:nowrap;">Standard Fields</span>
      <div style="height:1px;flex:1;background:#e5e7eb;"></div>
    </div>
    <!-- id is load-bearing: app_tour.js targets #field-types-grid. -->
    <div
      id="field-types-grid"
      class="flex flex-col gap-1 fields-grid"
    >
      <template
        v-for="(icon, type) in filteredFieldIcons"
        :key="type"
      >
        <FieldTypeButton
          v-if="fieldTypes.includes(type) || ((withPhone || type != 'phone') && (withPayment || type != 'payment') && (withVerification || type != 'verification'))"
          :type="type"
          :icon="icon"
          :label="fieldNames[type]"
          :armed="drawFieldType === type"
          :background-color="backgroundColor"
          @dragstart="onDragstart($event, { type: type })"
          @dragend="$emit('drag-end')"
          @click="(event, meta) => onFieldTypeButtonClick(type, meta)"
          @keydown.enter.prevent="addFieldFromKeyboard(type)"
          @keydown.space.prevent="addFieldFromKeyboard(type)"
        />
        <div
          v-else-if="withVerification === false && type == 'verification' && (fieldTypes.length === 0 || fieldTypes.includes(type))"
          class="tooltip tooltip-bottom flex tooltip-bottom-start"
          :data-tip="t('obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more')"
        >
          <a
            href="https://www.docuseal.com/qualified-electronic-signature"
            target="_blank"
            class="opacity-50 flex items-center border border-dashed border-base-300 w-full rounded relative fields-grid-item"
            :style="{ backgroundColor }"
          >
            <div class="w-0 absolute left-0">
              <IconLock
                width="18"
                height="18"
                stroke-width="1.5"
              />
            </div>
            <div class="flex items-center gap-2 pl-5 pr-2 py-1.5">
              <component :is="icon" />
              <span class="text-sm">
                {{ fieldNames[type] }}
              </span>
            </div>
          </a>
        </div>
      </template>
    </div>
    <div v-if="filteredSmartFields.length">
      <div style="display:flex;align-items:center;gap:6px;padding:8px 4px 4px;">
        <div style="height:1px;flex:1;background:#e5e7eb;"></div>
        <span style="font-size:10px;font-weight:700;color:#9ca3af;letter-spacing:.8px;text-transform:uppercase;white-space:nowrap;">Smart Fields</span>
        <div style="height:1px;flex:1;background:#e5e7eb;"></div>
      </div>
      <div class="flex flex-col gap-1">
        <button
          v-for="smartField in filteredSmartFields"
          :key="smartField.name"
          draggable="true"
          class="field-type-button group flex items-center border border-dashed border-base-300 hover:border-base-content/20 w-full rounded relative fields-grid-item"
          :style="{ backgroundColor }"
          @dragstart="onSmartFieldButtonDragstart($event, smartField)"
          @drag="onSmartFieldButtonDrag"
          @dragend="onSmartFieldButtonDragend($event, smartField)"
          @click="addSmartField(smartField)"
          @keydown.enter.prevent="addSmartFieldFromKeyboard(smartField)"
          @keydown.space.prevent="addSmartFieldFromKeyboard(smartField)"
        >
          <!-- pl-5 with no drag handle of its own, matching field_type_button.vue's rows, so
               every label in the list lines up at the same x. -->
          <div class="flex items-center gap-2 pl-5 pr-2 py-1.5">
            <div :style="{ width:'24px', height:'24px', borderRadius:'5px', background: smartField.color + '15', display:'flex', alignItems:'center', justifyContent:'center', color: smartField.color, flexShrink: 0 }" v-html="smartField.svg"></div>
            <span class="text-sm">{{ smartField.label }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div
    v-if="fields.length < 4 && editable && withHelp && !showTourStartForm"
    style="border-radius:8px;background:#f8fafc;border:1px solid #e2e8f0;padding:10px 12px;margin-top:4px;"
  >
    <div style="display:flex;align-items:center;gap:6px;margin-bottom:6px;">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      <span style="font-size:10px;font-weight:700;color:#64748b;letter-spacing:.5px;text-transform:uppercase;">How to add fields</span>
    </div>
    <div style="display:flex;flex-direction:column;gap:4px;">
      <!-- Click-to-place leads now that a bare click drops a default-sized field; drawing is the
           alternative, not the entry point. English literals like the block's own heading above:
           the old t() keys are all named after drawing and their translations describe it. -->
      <div style="display:flex;align-items:flex-start;gap:6px;font-size:11px;color:#64748b;">
        <span style="color:#94a3b8;flex-shrink:0;">①</span>
        <span>Click a field type, then click the page to place it</span>
      </div>
      <div style="display:flex;align-items:flex-start;gap:6px;font-size:11px;color:#64748b;">
        <span style="color:#94a3b8;flex-shrink:0;">②</span>
        <span>Or drag a field type onto the page</span>
      </div>
      <div style="display:flex;align-items:flex-start;gap:6px;font-size:11px;color:#64748b;">
        <span style="color:#94a3b8;flex-shrink:0;">③</span>
        <span>Drag a placed field's corner to resize it</span>
      </div>
    </div>
  </div>
  <div
    v-if="withFieldsDetection && editable && fields.length < 2"
    class="my-2"
  >
    <button
      :style="{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        width: '100%',
        padding: '9px 14px',
        borderRadius: '8px',
        border: '1.5px dashed #c4b5fd',
        background: fieldPagesLoaded !== null ? '#f5f3ff' : '#faf5ff',
        cursor: fieldPagesLoaded !== null ? 'default' : 'pointer',
        fontSize: '12px',
        fontWeight: '600',
        color: '#7c3aed',
        transition: 'background 0.15s'
      }"
      @mouseenter="$event.currentTarget.style.background = fieldPagesLoaded !== null ? '#f5f3ff' : '#f3e8ff'"
      @mouseleave="$event.currentTarget.style.background = fieldPagesLoaded !== null ? '#f5f3ff' : '#faf5ff'"
      @click="fieldPagesLoaded !== null ? null : detectFields()"
    >
      <template v-if="fieldPagesLoaded !== null">
        <IconInnerShadowTop width="16" class="animate-spin" style="color:#7c3aed;" />
        <span v-if="analyzingProgress">{{ Math.round(analyzingProgress * 100) }}% {{ t('analyzing_') }}</span>
        <span v-else>{{ fieldPagesLoaded }} / {{ numberOfPages }} {{ t('processing_') }}</span>
      </template>
      <template v-else>
        <IconSparkles width="16" style="color:#7c3aed;" />
        <span>{{ t('autodetect_fields') }}</span>
      </template>
    </button>
  </div>
  <div
    v-show="fields.length < 4 && editable && withHelp && showTourStartForm"
    class="rounded py-2 px-4 w-full border border-dashed border-base-300"
  >
    <div class="text-center text-sm">
      {{ t('start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document') }}
    </div>
    <div class="flex justify-center">
      <label
        for="start_tour_button"
        class="btn btn-sm btn-primary w-40 mt-2"
        @click="startTour"
      >
        {{ t('start_tour') }}
      </label>
    </div>
  </div>
  <ConditionsModal
    v-if="isBulkConditionModal"
    :item="{ uuid: 'bulk', name: 'Selected Fields (' + (selectedFieldUuids ? selectedFieldUuids.value.size : 0) + ')', type: 'text', conditions: [] }"
    :build-default-name="buildDefaultName"
    @close="isBulkConditionModal = false"
    @save="applyBulkCondition"
  />
</template>

<script>
import Field from './field'
import ConditionsModal from './conditions_modal'
import FieldType from './field_type'
import FieldSubmitter from './field_submitter'
import FieldTypeButton from './field_type_button'
import { IconLock, IconCirclePlus, IconInnerShadowTop, IconSparkles } from '@tabler/icons-vue'
import IconDrag from './icon_drag'

// Same threshold and path-based reasoning as field_type_button.vue's CLICK_DISTANCE_THRESHOLD
// (see there): the SMART FIELDS buttons below are hand-rolled rather than that component, so
// they need their own copy of the drag-vs-click tracking rather than getting it for free.
const SMART_FIELD_CLICK_DISTANCE_THRESHOLD = 5

export default {
  name: 'TemplateFields',
  components: {
    ConditionsModal,
    Field,
    FieldType,
    FieldTypeButton,
    IconCirclePlus,
    IconSparkles,
    IconInnerShadowTop,
    FieldSubmitter,
    IconDrag,
    IconLock
  },
  inject: ['selectedFieldUuids', 'alignmentFieldUuids', 'save', 'backgroundColor', 'withPhone', 'withVerification', 'withPayment', 't', 'fieldsDragFieldRef', 'baseFetch', 'template'],
  props: {
    fields: {
      type: Array,
      required: true
    },
    withFieldsSearch: {
      type: Boolean,
      required: false,
      default: null
    },
    withFieldsDetection: {
      type: Boolean,
      required: false,
      default: false
    },
    withSignatureId: {
      type: Boolean,
      required: false,
      default: null
    },
    withPrefillable: {
      type: Boolean,
      required: false,
      default: false
    },
    template: {
      type: Object,
      required: true
    },
    withHelp: {
      type: Boolean,
      required: false,
      default: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    defaultFields: {
      type: Array,
      required: false,
      default: () => []
    },
    defaultRequiredFields: {
      type: Array,
      required: false,
      default: () => []
    },
    onlyDefinedFields: {
      type: Boolean,
      required: false,
      default: true
    },
    drawFieldType: {
      type: String,
      required: false,
      default: ''
    },
    defaultSubmitters: {
      type: Array,
      required: false,
      default: () => []
    },
    withStickySubmitters: {
      type: Boolean,
      required: false,
      default: true
    },
    fieldTypes: {
      type: Array,
      required: false,
      default: () => []
    },
    submitters: {
      type: Array,
      required: true
    },
    selectedSubmitter: {
      type: Object,
      required: true
    },
    showTourStartForm: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['add-field', 'set-draw', 'set-draw-type', 'set-drag', 'drag-end', 'scroll-to-area', 'change-submitter', 'set-drag-placeholder', 'select-submitter', 'set-smart-field', 'add-field-in-view'],
  data () {
    return {
      isBulkConditionModal: false,
      fieldPagesLoaded: null,
      analyzingProgress: 0,
      defaultFieldsSearch: '',
      paletteSearch: '',
      smartFields: [
        { label: 'Full Name', name: 'full_name', type: 'text', color: '#3B82F6', validation: null, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>' },
        { label: 'Email', name: 'email', type: 'text', color: '#10B981', validation: { pattern: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$', message: '' }, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' },
        { label: 'Phone', name: 'phone_number', type: 'text', color: '#10B981', validation: null, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>' },
        { label: 'SSN', name: 'ssn', type: 'text', color: '#3B82F6', validation: { pattern: '^[0-9]{3}-[0-9]{2}-[0-9]{4}$', message: '' }, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' },
        { label: 'DOB', name: 'date_of_birth', type: 'date', color: '#8B5CF6', validation: null, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' },
        { label: 'Address', name: 'address', type: 'text', color: '#10B981', validation: null, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>' },
        { label: 'ZIP', name: 'zip_code', type: 'text', color: '#10B981', validation: { pattern: '^[0-9]{5}(?:-[0-9]{4})?$', message: '' }, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>' },
        { label: 'EIN', name: 'ein', type: 'text', color: '#3B82F6', validation: { pattern: '^[0-9]{2}-[0-9]{7}$', message: '' }, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>' },
        { label: 'City', name: 'city', type: 'text', color: '#10B981', validation: null, svg: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="22" x2="21" y2="22"/><rect x="9" y="2" width="6" height="20"/><path d="M3 22V11l6-9M21 22V11l-6-9"/></svg>' }
      ],
      // Drag-vs-click tracking for the SMART FIELDS buttons (onSmartFieldButtonDragstart/Drag/
      // Dragend below) -- one pair of fields rather than one per button, because only one
      // native drag can be in flight at a time regardless of how many buttons are rendered.
      smartFieldDragStartPoint: null,
      smartFieldDragMoved: false
    }
  },
  computed: {
    fieldNames: FieldType.computed.fieldNames,
    fieldIcons: FieldType.computed.fieldIcons,
    numberOfPages () {
      return this.template.documents.reduce((acc, doc) => {
        return acc + doc.metadata?.pdf?.number_of_pages || doc.preview_images.length
      }, 0)
    },
    // Types surviving the palette search. The per-button v-if that gates phone/payment/
    // verification still applies on top, which is why the count below is computed the same way
    // rather than read off this object's length.
    filteredFieldIcons () {
      const query = this.paletteSearch.trim().toLowerCase()

      if (!query) return this.fieldIconsSorted

      return Object.keys(this.fieldIconsSorted).reduce((acc, type) => {
        const label = (this.fieldNames[type] || type).toLowerCase()

        if (label.includes(query) || type.includes(query)) acc[type] = this.fieldIconsSorted[type]

        return acc
      }, {})
    },
    filteredFieldTypeCount () {
      return Object.keys(this.filteredFieldIcons).filter((type) => {
        return this.fieldTypes.includes(type) ||
          ((this.withPhone || type !== 'phone') &&
           (this.withPayment || type !== 'payment') &&
           (this.withVerification || type !== 'verification'))
      }).length
    },
    filteredSmartFields () {
      const query = this.paletteSearch.trim().toLowerCase()

      if (!query) return this.smartFields

      return this.smartFields.filter((smartField) => {
        return smartField.label.toLowerCase().includes(query) || smartField.name.includes(query)
      })
    },
    isShowFieldSearch () {
      if (this.withFieldsSearch === false) {
        return false
      } else {
        return this.submitterDefaultFields.length > 15
      }
    },
    defaultFieldsIndex () {
      return this.defaultFields.reduce((acc, field) => {
        acc[field.name] = field

        return acc
      }, {})
    },
    skipTypes () {
      return ['heading', 'strikethrough']
    },
    fieldIconsSorted () {
      if (this.fieldTypes.length) {
        return this.fieldTypes.reduce((acc, type) => {
          acc[type] = this.fieldIcons[type]

          return acc
        }, {})
      } else {
        return Object.fromEntries(Object.entries(this.fieldIcons).filter(([key]) => !this.skipTypes.includes(key)))
      }
    },
    submitterFields () {
      return this.fields.filter((f) => f.submitter_uuid === this.selectedSubmitter.uuid)
    },
    submitterDefaultFields () {
      return this.defaultFields.filter((f) => {
        return !this.submitterFields.find((field) => field.name === f.name) && (!f.role || f.role === this.selectedSubmitter.name)
      })
    },
    filteredSubmitterDefaultFields () {
      if (this.defaultFieldsSearch) {
        return this.submitterDefaultFields.filter((f) => (f.title || f.name).toLowerCase().includes(this.defaultFieldsSearch.toLowerCase()))
      } else {
        return this.submitterDefaultFields
      }
    }
  },
  methods: {
    buildDefaultName (field, fields) {
      const sameTypeFields = fields.filter(f => f.type === field.type)
      const index = sameTypeFields.indexOf(field)
      const fieldNames = { text: 'Text', signature: 'Signature', date: 'Date', number: 'Number', checkbox: 'Checkbox', select: 'Select', radio: 'Radio' }
      const typeName = fieldNames[field.type] || field.type
      return typeName + ' Field ' + (index + 1)
    },
    toggleFieldSelect (e, field) {
      if (!e.ctrlKey && !e.metaKey) return
      e.preventDefault()
      e.stopPropagation()
      const newSet = new Set(this.selectedFieldUuids.value)
      if (newSet.has(field.uuid)) {
        newSet.delete(field.uuid)
      } else {
        newSet.add(field.uuid)
      }
      this.selectedFieldUuids.value = newSet
    },
    bulkSelectedFields () {
      const uuids = [...this.selectedFieldUuids.value]
      return this.template.fields.filter(f => uuids.includes(f.uuid))
    },
    bulkAllText () {
      const fields = this.bulkSelectedFields()
      return fields.length > 0 && fields.every(f => f.type === 'text' || !f.type)
    },
    bulkAllRequired () {
      return this.bulkSelectedFields().every(f => f.required)
    },
    bulkAllReadonly () {
      return this.bulkSelectedFields().every(f => f.readonly)
    },
    bulkValidation () {
      const fields = this.bulkSelectedFields()
      if (!fields.length) return 'none'
      const pattern = fields[0].validation?.pattern
      if (!pattern) return 'none'
      const map = {
        '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$': 'email',
        '^https?://.*': 'url',
        '^[0-9]+$': 'numbers',
        '^[a-zA-Z]+$': 'letters',
        '^[0-9]{5}(?:-[0-9]{4})?$': 'zip',
        '^[0-9]{3}-[0-9]{2}-[0-9]{4}$': 'ssn',
        '^[0-9]{2}-[0-9]{7}$': 'ein'
      }
      return map[pattern] || 'none'
    },
    bulkFont () {
      const fields = this.bulkSelectedFields()
      if (!fields.length) return ''
      return fields[0].preferences?.font || ''
    },
    bulkFontSize () {
      const fields = this.bulkSelectedFields()
      if (!fields.length) return ''
      return fields[0].preferences?.font_size?.toString() || ''
    },
    // The recipient a field belongs to lives on `submitter_uuid` — the same attribute the
    // per-field RECIPIENT picker writes — so a bulk reassignment reuses the existing data path
    // rather than inventing one. Shape deliberately identical to setBulkProp below: walk
    // template.fields once, mutate the selected uuids, save.
    setBulkSubmitter (uuid) {
      const uuids = [...this.selectedFieldUuids.value]

      this.template.fields.forEach(f => {
        if (uuids.includes(f.uuid)) f.submitter_uuid = uuid
      })

      this.save()
    },
    // Which recipient the whole selection belongs to, or '' when it spans more than one.
    // '' drives the disabled "Mixed" option in the Bulk Edit panel: showing the first field's
    // recipient instead would misreport what is selected.
    bulkSubmitterUuid () {
      const fields = this.bulkSelectedFields()

      if (!fields.length) return ''

      const first = fields[0].submitter_uuid

      return fields.every((f) => f.submitter_uuid === first) ? first : ''
    },
    setBulkProp (prop, value) {
      const uuids = [...this.selectedFieldUuids.value]
      this.template.fields.forEach(f => {
        if (uuids.includes(f.uuid)) f[prop] = value
      })
      this.save()
    },
    setBulkValidation (value) {
      const uuids = [...this.selectedFieldUuids.value]
      const patterns = {
        email: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',
        url: '^https?://.*',
        numbers: '^[0-9]+$',
        letters: '^[a-zA-Z]+$',
        zip: '^[0-9]{5}(?:-[0-9]{4})?$',
        ssn: '^[0-9]{3}-[0-9]{2}-[0-9]{4}$',
        ein: '^[0-9]{2}-[0-9]{7}$'
      }
      this.template.fields.forEach(f => {
        if (uuids.includes(f.uuid)) {
          if (value === 'none') {
            delete f.validation
          } else {
            f.validation = { pattern: patterns[value], message: '' }
          }
        }
      })
      this.save()
    },
    setBulkFont (value) {
      const uuids = [...this.selectedFieldUuids.value]
      this.template.fields.forEach(f => {
        if (uuids.includes(f.uuid)) {
          f.preferences ||= {}
          if (value) {
            f.preferences.font = value
          } else {
            delete f.preferences.font
          }
        }
      })
      this.save()
    },
    setBulkFontSize (value) {
      const uuids = [...this.selectedFieldUuids.value]
      this.template.fields.forEach(f => {
        if (uuids.includes(f.uuid)) {
          f.preferences ||= {}
          if (value) {
            f.preferences.font_size = parseInt(value)
          } else {
            delete f.preferences.font_size
          }
        }
      })
      this.save()
    },
    clearAlignmentSelection () {
      this.alignmentFieldUuids.value = new Set()
    },
    addSmartField (smartField) {
      this.$emit('set-smart-field', smartField)
      this.$emit('set-draw-type', smartField.type)
    },
    // A recovered click is field_type_button.vue's onDragend synthesizing a click back after the
    // browser stole a genuine one (see there). For file/payment/verification that would reach
    // addField with no area -- a required field the recipient can never place -- so a recovered
    // click on those three is a no-op instead; the user just clicks again. The draw types have
    // no such hazard (they only arm place-mode), so a recovered click still arms them exactly
    // like a genuine one.
    onFieldTypeButtonClick (type, meta) {
      const isNoAreaType = ['file', 'payment', 'verification'].includes(type)

      if (meta?.recovered && isNoAreaType) return

      if (isNoAreaType) {
        this.$emit('add-field', type)
      } else {
        this.$emit('set-draw-type', type)
      }
    },
    // Enter/Space on a focused field type places the field straight away, the way DocuSign's
    // "Add Field" shortcut does. Clicking still arms place-mode and waits for a spot on the
    // page; a keyboard user has no pointer to give one with, so the builder picks the page in
    // view. .prevent is what stops the browser turning the key into a click and arming
    // place-mode on top of this.
    addFieldFromKeyboard (type) {
      if (['file', 'payment', 'verification'].includes(type)) {
        this.$emit('add-field', type)
      } else {
        this.$emit('add-field-in-view', { type })
      }
    },
    addSmartFieldFromKeyboard (smartField) {
      this.$emit('set-smart-field', smartField)
      this.$emit('add-field-in-view', { type: smartField.type })
    },
    onSmartFieldDragstart (event, smartField) {
      this.$emit('set-smart-field', smartField)
      this.onDragstart(event, { type: smartField.type, name: smartField.name })
    },
    // The SMART FIELDS buttons are hand-rolled rather than FieldTypeButton (their icon is raw
    // SVG markup coloured per-field via v-html, not the icon-component prop FieldTypeButton
    // expects), so they need their own copy of its drag-vs-click tracking -- see there for why
    // an endpoint-only distance check is wrong and why a { clientX: 0, clientY: 0 } sample is
    // ignored. Unlike file/payment/verification's field-type buttons, no recovered-click
    // gating is needed: addSmartField only emits set-smart-field and set-draw-type, never
    // addField, so there's no unplaced-required-field hazard to route around here -- this fixes
    // the intermittent failure to arm, not a data hazard.
    onSmartFieldButtonDragstart (event, smartField) {
      this.smartFieldDragStartPoint = { x: event.clientX, y: event.clientY }
      this.smartFieldDragMoved = false

      this.onSmartFieldDragstart(event, smartField)
    },
    onSmartFieldButtonDrag (event) {
      if (event.clientX === 0 && event.clientY === 0) return

      if (!this.smartFieldDragStartPoint || this.smartFieldDragMoved) return

      const distance = Math.hypot(event.clientX - this.smartFieldDragStartPoint.x, event.clientY - this.smartFieldDragStartPoint.y)

      if (distance >= SMART_FIELD_CLICK_DISTANCE_THRESHOLD) {
        this.smartFieldDragMoved = true
      }
    },
    onSmartFieldButtonDragend (event, smartField) {
      const start = this.smartFieldDragStartPoint
      const moved = this.smartFieldDragMoved

      this.smartFieldDragStartPoint = null
      this.smartFieldDragMoved = false

      this.$emit('drag-end')

      if (start && !moved) {
        this.addSmartField(smartField)
      }
    },
    alignFields (direction) {
      const uuids = [...this.alignmentFieldUuids.value]
      const selectedFields = this.template.fields.filter(f => uuids.includes(f.uuid))
      const allAreas = selectedFields.flatMap(f => (f.areas || []).map(a => ({ area: a, field: f })))

      if (allAreas.length === 0) return

      if (direction === 'left') {
        const minX = Math.min(...allAreas.map(({ area }) => area.x))
        allAreas.forEach(({ area }) => { area.x = minX })
      } else if (direction === 'right') {
        const maxX = Math.max(...allAreas.map(({ area }) => area.x + area.w))
        allAreas.forEach(({ area }) => { area.x = maxX - area.w })
      } else if (direction === 'center') {
        const minX = Math.min(...allAreas.map(({ area }) => area.x))
        const maxX = Math.max(...allAreas.map(({ area }) => area.x + area.w))
        const centerX = (minX + maxX) / 2
        allAreas.forEach(({ area }) => { area.x = centerX - area.w / 2 })
      } else if (direction === 'top') {
        const minY = Math.min(...allAreas.map(({ area }) => area.y))
        allAreas.forEach(({ area }) => { area.y = minY })
      } else if (direction === 'bottom') {
        const maxY = Math.max(...allAreas.map(({ area }) => area.y + area.h))
        allAreas.forEach(({ area }) => { area.y = maxY - area.h })
      } else if (direction === 'middle') {
        const minY = Math.min(...allAreas.map(({ area }) => area.y))
        const maxY = Math.max(...allAreas.map(({ area }) => area.y + area.h))
        const centerY = (minY + maxY) / 2
        allAreas.forEach(({ area }) => { area.y = centerY - area.h / 2 })
      }
      this.save()
    },
    clearSelection () {
      this.selectedFieldUuids.value = new Set()
      this.isBulkConditionModal = false
    },

    applyBulkCondition (conditions) {
      const plainConditions = JSON.parse(JSON.stringify(conditions))
      const uuids = [...this.selectedFieldUuids.value]
      this.template.fields.forEach(f => {
        if (uuids.includes(f.uuid)) {
          if (plainConditions && plainConditions.length && plainConditions.find(c => c.field_uuid)) {
            f.conditions = plainConditions
          } else {
            delete f.conditions
          }
        }
      })
      this.selectedFieldUuids.value = new Set()
      this.isBulkConditionModal = false
      this.save()
    },
    // Shared by the default-fields list, the field-type grid (now FieldTypeButton, which
    // handles its own click-vs-drag disambiguation internally) and smart fields via
    // onSmartFieldDragstart below.
    onDragstart (event, field) {
      this.removeDragOverlay(event)

      this.setDragPlaceholder(event)

      this.$emit('set-drag', field)
    },
    detectFields () {
      const fields = []

      this.fieldPagesLoaded = 0

      this.baseFetch(`/templates/${this.template.id}/detect_fields`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(async (response) => {
        const reader = response.body.getReader()
        const decoder = new TextDecoder('utf-8')
        let buffer = ''

        while (true) {
          const { value, done } = await reader.read()

          buffer += decoder.decode(value, { stream: true })

          const lines = buffer.split('\n\n')

          buffer = lines.pop()

          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const jsonStr = line.replace(/^data: /, '')
              const data = JSON.parse(jsonStr)

              if (data.error) {
                if ((data.fields || fields).length) {
                  this.template.fields = data.fields || fields

                  this.save()
                } else {
                  alert(data.error)
                }

                break
              } else if (data.analyzing) {
                this.analyzingProgress = data.progress
              } else if (data.completed) {
                this.fieldPagesLoaded = null

                if (data.submitters) {
                  this.template.submitters = data.submitters
                  this.$emit('select-submitter', this.template.submitters[0])
                }

                this.template.fields = data.fields || fields

                this.save()

                break
              } else if (data.fields) {
                data.fields.forEach((f) => {
                  if (!f.submitter_uuid) {
                    f.submitter_uuid = this.template.submitters[0].uuid
                  }
                })

                this.fieldPagesLoaded += 1

                fields.push(...data.fields)
              }
            }
          }

          if (done) break
        }
      }).catch(error => {
        console.error('Error in streaming message: ', error)
      }).finally(() => {
        this.fieldPagesLoaded = null
        this.analyzingProgress = null
        this.isFieldsLoading = false
      })
    },
    setDragPlaceholder (event) {
      this.$emit('set-drag-placeholder', {
        offsetX: event.offsetX,
        offsetY: event.offsetY,
        x: event.clientX - event.offsetX,
        y: event.clientY - event.offsetY,
        w: event.currentTarget.clientWidth + 2,
        h: event.currentTarget.clientHeight + 2
      })
    },
    removeDragOverlay (event) {
      const root = this.$el.getRootNode()
      const hiddenEl = document.createElement('div')

      hiddenEl.style.width = '1px'
      hiddenEl.style.height = '1px'
      hiddenEl.style.opacity = '0'
      hiddenEl.style.position = 'fixed'

      root.querySelector('#docuseal_modal_container').appendChild(hiddenEl)

      event.dataTransfer.setDragImage(hiddenEl, 0, 0)

      setTimeout(() => { hiddenEl.remove() }, 1000)
    },
    startTour () {
      document.querySelector('app-tour').start()
    },
    onFieldDragover (e) {
      if (this.fieldsDragFieldRef.value) {
        const targetField = e.target.closest('[data-uuid]')
        const dragField = this.$refs.fields.querySelector(`[data-uuid="${this.fieldsDragFieldRef.value.uuid}"]`)

        if (dragField && targetField && targetField !== dragField) {
          const fields = Array.from(this.$refs.fields.children)
          const currentIndex = fields.indexOf(dragField)
          const targetIndex = fields.indexOf(targetField)

          if (currentIndex < targetIndex) {
            targetField.after(dragField)
          } else {
            targetField.before(dragField)
          }
        }
      }
    },
    reorderFields () {
      Array.from(this.$refs.fields.children).forEach((el, index) => {
        if (el.dataset.uuid !== this.fields[index].uuid) {
          const field = this.fields.find((f) => f.uuid === el.dataset.uuid)

          this.fields.splice(this.fields.indexOf(field), 1)
          this.fields.splice(index, 0, field)
        }
      })

      this.save()
    },
    removeSubmitter (submitter) {
      [...this.fields].forEach((field) => {
        if (field.submitter_uuid === submitter.uuid) {
          this.removeField(field)
        }
      })

      this.submitters.splice(this.submitters.indexOf(submitter), 1)

      if (this.selectedSubmitter === submitter) {
        this.$emit('change-submitter', this.submitters[0])
      }

      this.save()
    },
    removeField (field) {
      this.fields.splice(this.fields.indexOf(field), 1)

      this.fields.forEach((f) => {
        (f.conditions || []).forEach((c) => {
          if (c.field_uuid === field.uuid) {
            f.conditions.splice(f.conditions.indexOf(c), 1)
          }
        })
      })

      this.template.schema.forEach((item) => {
        (item.conditions || []).forEach((c) => {
          if (c.field_uuid === field.uuid) {
            item.conditions.splice(item.conditions.indexOf(c), 1)
          }
        })
      })

      this.save()
    }
  }
}
</script>
